import React from "react";
import styled from "styled-components";






const CheckoutButton = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
position: absolute;
bottom: 0;
height: 60px;
left: 0;
box-shadow: rgba(0, 0, 0, 0.1) 0px -2px 16px;
background-color: #f2f2f2;


`



export default function CheckoutMobile() {





return(


<CheckoutButton>
    <div>
        <p>Proceed to Checkout</p>
    </div>

</CheckoutButton>


)

}